export const DETAILED_INFO_TYPES = [
  { key: 'comments', i18n: 'tickets.detailed_info.comments' },
  { key: 'history', i18n: 'tickets.detailed_info.history' },
];

export const SMALL_DEVICE_WIDTH = 950;

export const ASSIGNEE_SEARCH_MIN_LENGTH = 3;

export const MOBILE_WIDTH = 650;
